import * as React from 'react';
import { mergeStyles } from '@cian/utils';

import * as stylesCommon from '../FiltersCommon/FiltersCommon.css';
import * as styles from './styles.css';

export interface IFilterTextInputProps extends React.ComponentProps<'input'> {
  className?: string;
  suffix?: React.ReactNode;
  grow?: number;
}

export const FilterTextInput: React.FC<IFilterTextInputProps> = props => {
  const { className, suffix, grow, ...inputProps } = props;

  return (
    <div
      {...mergeStyles(stylesCommon['container'], styles['container'], className, Boolean(grow) && { flexGrow: grow })}
      data-mark="FilterTextInput"
    >
      <input type="text" className={stylesCommon['input']} {...inputProps} />
      {suffix && <span {...mergeStyles(styles['suffix'])}>{suffix}</span>}
    </div>
  );
};

FilterTextInput.displayName = 'FilterTextInput';
